module.exports = __webpack_public_path__ + "static/fractal_tree-a1a650ea5af29bfe226eb5bd5b3bf927.png";